import { useQuery } from "@tanstack/react-query";

import { commonQueryKeys } from "@/common/data/commonQueryKeys";
import api from "@/common/utils/api";

export function useOrgsData({ retry = false }: { retry?: boolean } = {}) {
  return useQuery({
    queryKey: commonQueryKeys.orgs,
    queryFn: () => api.get<"/orgs">("/orgs").then((res) => res.data),
    refetchOnWindowFocus: false,
    retry,
    retryDelay: 1000,
    staleTime: Infinity,
  });
}
